import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette } = lightTheme;
const styles: Record<string, SxProps> = {
  container: {
    height: '100%',
    width: '100%',
    paddingTop: '1.5rem',
    display: 'flex',
    flex: 1
  },
  title: {
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '1.25rem',
    color: palette.grey.main
  },
  subTitle: {
    fontSize: '1rem',
    fontWeight: 400,
    color: palette.grey.main,
    paddingTop: '1.5rem'
  },
  textField: {
    paddingTop: '1rem',
    width: '100%'
  },
  buttonContainer: {
    height: '100%',
    paddingTop: '1.5rem'
  }
};

export default styles;
